import React from 'react';
import Form from '../components/Form/Form';

function SignupPage(props) {
    return (
      <Form/>
    );
}

export default SignupPage;